import * as moment from "moment";

export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const SERVER_DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "hh:mm:ss a";
export const GLOBAL_TIME_FROM = new Date(
  process.env.REACT_APP_GLOBAL_TIME_FROM || "2026-10-13T00:00:00.000Z",
);

export const castToTimeFormat = (date) => {
  return moment(date).isValid() ? moment(date).format(TIME_FORMAT) : "";
};

export const castToISTDateTimeFormat = (date) => {
  const d = new Date(date);
  if (!date || isNaN(d)) return "";
  return d.toLocaleString("en-GB", {
    timeZone: d >= GLOBAL_TIME_FROM ? "Asia/Kolkata" : "UTC",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const castToDefaultDateFormat = (date) => {
  date = moment(date);
  return date.isValid() ? moment(date).format(DEFAULT_DATE_FORMAT) : "";
};

export const castToServerDateFormat = (date) => {
  date = moment(date);
  return date.isValid() ? moment(date).format(SERVER_DATE_FORMAT) : "";
};

const IST_OFFSET_MINUTES = 330

const formatInIST = (date, format) => {
    if (!date) return ''
    const m = moment(date)
    return m.isValid() ? m.utcOffset(IST_OFFSET_MINUTES).format(format) : ''
}

export const castToISTTimeFormat = (date) => formatInIST(date, TIME_FORMAT)

export const castToISTDefaultDateFormat = (date) => formatInIST(date, DEFAULT_DATE_FORMAT)

export const castToISTServerDateFormat = (date) => formatInIST(date, SERVER_DATE_FORMAT)
